module.exports = __webpack_public_path__ + "img/map_pc_7.3d617281.png";